export function getWeatherAndRouteData(components) {
    var _a, _b;
    const result = {};
    if (!components)
        return result;
    components.forEach((component) => {
        const { __typename } = component;
        switch (__typename) {
            case 'ComponentGroup':
                // Handle ComponentGroup
                component.components.forEach((subComponent) => {
                    subComponent === null || subComponent === void 0 ? void 0 : subComponent.content.forEach((childComponent) => {
                        if (childComponent.__typename === 'WeatherItemGroup')
                            result.weatherData = childComponent;
                        if (childComponent.__typename === 'FlightRoute')
                            result.routeData = childComponent;
                    });
                });
                break;
            case 'GenericComponent':
                //  handle GenericComponent
                component.content.forEach((subComponent) => {
                    if (subComponent.__typename === 'WeatherItemGroup')
                        result.weatherData = subComponent;
                    if (subComponent.__typename === 'FlightRoute')
                        result.routeData = subComponent;
                });
                break;
            default:
                break;
        }
    });
    const routeItems = (_b = (_a = result.routeData) === null || _a === void 0 ? void 0 : _a.routeItems) === null || _b === void 0 ? void 0 : _b.filter(({ routeDescription, routeDuration, routePopularDestinations }) => routeDescription || routeDuration || routePopularDestinations);
    result.routeData = (routeItems === null || routeItems === void 0 ? void 0 : routeItems.length) ? Object.assign(Object.assign({}, result.routeData), { routeItems }) : undefined;
    return result;
}
